import { RefreshButtonModel, SiteOrUserModel } from '@shared/models';
import { createContext, Dispatch } from 'react';

export const SharedReducerDefaultValues = {
  sites: null as SiteOrUserModel[],
  refreshButton: {
    show: false,
    disabled: true,
    onClick: () => {},
  } as RefreshButtonModel,
};

export enum SharedActionType {
  SetSites = 'SetSite',
  SetRefreshButton = 'SetRefreshButton',
}

type State = typeof SharedReducerDefaultValues;
type Action = {
  type: SharedActionType;
  payload: SiteOrUserModel[] | RefreshButtonModel;
};

export const sharedReducer = (state: State, action: Action): State => {
  const { type, payload } = action;
  switch (type) {
    case SharedActionType.SetSites:
      return {
        ...state,
        sites: payload as SiteOrUserModel[],
      };
    case SharedActionType.SetRefreshButton:
      return {
        ...state,
        refreshButton: payload as RefreshButtonModel,
      };
    default:
      return state;
  }
};

export const SharedContext = createContext<{
  state?: State;
  dispatch?: Dispatch<Action>;
}>({});
